import PropTypes from 'prop-types';
import cx from 'classnames';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import { RightOutlined } from '@ant-design/icons';
import { createElement } from 'react';

import './index.less';

function MenuSelector({ children, icon, onClick, selected, subtitle, to, ...props }) {
  const button = (
    <Button
      data-testid={props['data-testid']}
      className={cx('menu-selector__button', { 'menu-selector__button--selected': selected })}
      onClick={onClick}
      block
    >
      {createElement(icon, { className: 'menu-selector__icon' })}
      <div className="menu-selector__text">
        <div className="menu-selector__title">{children}</div>
        <div className="menu-selector__subtitle">{subtitle}</div>
      </div>
      <RightOutlined className="menu-selector__arrow" />
    </Button>
  );
  return to ? (
    <Link to={to} className="menu-selector">
      {button}
    </Link>
  ) : (
    button
  );
}

MenuSelector.propTypes = {
  children: PropTypes.node.isRequired,
  icon: PropTypes.func,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  subtitle: PropTypes.node,
  to: PropTypes.string,
  'data-testid': PropTypes.string,
};

export default MenuSelector;
